import TableRow from "@material-ui/core/TableRow";
import React, { FC } from "react";
import { TableCell } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import useStyles from "./styles";

type Props = {
  kind: "page" | "table" | "chart";
};

const LoadingAnimation: FC<Props> = ({ kind }) => {
  const classes = useStyles();
  return kind === "table" ? (
    <TableRow id="loading-animation">
      <TableCell colSpan={99}>
        <CircularProgress className={classes[kind]} color="primary" />
      </TableCell>
    </TableRow>
  ) : (
    <CircularProgress className={classes[kind]} color="primary" />
  );
};

export default LoadingAnimation;
